var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"monetizeSection"},[_c('h1',{staticClass:"monetizeTitle"},[_vm._v("Monetize your podcasts")]),_vm._v(" "),_c('p',{staticClass:"monetizeText"},[_vm._v("Earn money for your podcast through advertising and sponsorship from top global brands.")]),_vm._v(" "),_c('RouterLink',{staticClass:"btn-round-white monetizeButton",attrs:{"to":{ name: 'GhostPage', params: { slug: 'monetization' } }}},[_vm._v("\n    Find out more\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/pages/home/monetizeSection/MonetizeSection.vue